<template>
  <v-card
    :elevation="hovered ? 10 : 0"
    :loading="sirene.is_awaiting_response"
    :style="warn_state[0] === 'error' ? 'border: 4px solid #ff5252' : ''"
  >
    <v-card-title>
      {{ sirene.name }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div class="battery-wrapper" v-bind="attrs" v-on="on">
            <v-icon class="ml-1" :color="battery_voltage[1]">
              {{ battery_voltage[0] }}
            </v-icon>
            <span v-if="noRecentStatusMessage" class="battery-text">
              ???
            </span>
            <span v-else-if="battery_voltage[1] != 'success'" class="battery-text">
              {{ batteryVoltagePercent }}%
            </span>
          </div>
          <v-icon class="ml-1" :color="warn_state[0]" v-bind="attrs" v-on="on">
            {{ warn_state[1] }}
          </v-icon>
        </template>
        <span>Timestamp: {{ sirene.safi_timestamp }}</span
        ><br />
        <span>ActionNumber: {{ sirene.safi_ActionNumber }}</span
        ><br />
        <span
          >AccumulatorVoltage: {{ sirene.safi_AccumulatorVoltage }}V |
          {{ batteryVoltagePercent }}%</span
        ><br />
        <span>Temperature: {{ sirene.safi_Temperature }}°C</span><br />
        <span
          >InvalidPathsOfAmplifiers:
          {{ sirene.safi_InvalidPathsOfAmplifiers }}</span
        ><br />
        <span>TestValid: {{ sirene.safi_TestValid }}</span
        ><br />
        <span>Mains: {{ sirene.safi_Mains }}</span
        ><br />
        <span
          >Tetra-Türkontakt:
          {{ sirene.doorcontact_open ? "Offen" : "Geschlossen" }}</span
        ><br />
        <br />
        Beschreibung: <br />
        <span>{{ sirene.description }}</span
        ><br />
      </v-tooltip>
      <v-tooltip
        v-if="recentAlarmActive"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="ml-1"
            v-bind="attrs"
            v-on="on"
            color="error"
          >
            mdi-bell-ring-outline
          </v-icon>
        </template>
        <span>Aktive Alarmierung innerhalb der letztzen 30min</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            @click.stop="
              sirene.isNotificationsOn
                ? notificationsMute()
                : notificationsUnmute()
            "
          >
            <v-icon v-if="sirene.isNotificationsOn">
              mdi-message-bulleted
            </v-icon>
            <v-icon v-else color="error"> mdi-message-bulleted-off </v-icon>
          </v-btn>
        </template>
        <span v-if="sirene.isNotificationsOn"
          >Benachrichtigung sind eingeschaltet</span
        >
        <span v-else>Benachrichtigung sind deaktiviert</span>
      </v-tooltip>
      <Sirene_Download :sirene="sirene"></Sirene_Download>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            class="primary"
            x-small
            v-bind="attrs"
            v-on="on"
            @click.stop="
              copyToClipboard(
                sirene.name + ' / ' + sirene.name_safus + ', ' + sirene.address
              )
            "
          >
            {{ sirene.name_safus }}
          </v-chip>
          <v-snackbar v-model="snackbar" :timeout="2000"
            >Text wurde kopiert!</v-snackbar
          >
        </template>
        <span>{{ sirene.phonenumber }}</span>
      </v-tooltip>
    </v-card-title>
    <v-card-subtitle class="pb-0">
      {{ sirene.address }}
    </v-card-subtitle>
    <v-card-text style="height: 130px; overflow-y: auto">
      <v-tooltip v-for="(message, index) in messages" :key="index" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item class="pa-0" two-line dense v-bind="attrs" v-on="on">
            <v-list-item-content>
              <v-list-item-title>{{ message.message }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ formatTimestamp(message.timestamp) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ message.message }}</span>
      </v-tooltip>
    </v-card-text>
    <v-expand-transition>
      <v-card-actions v-if="selected">
        <v-btn
          class="warning"
          :disabled="loader !== null"
          :loading="loader === 'status'"
          @click.stop="status"
          >Status</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          class="error"
          :disabled="loader !== null"
          :loading="loader === 'sperren'"
          @click.stop="sperren"
          >Sperren</v-btn
        >
        <v-btn
          class="success"
          :disabled="loader !== null"
          :loading="loader === 'entsperren'"
          @click.stop="entsperren"
          >Entsperren</v-btn
        >
      </v-card-actions>
    </v-expand-transition>
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import Sirene_Download from "./Sirene_Download";
export default {
  components: { Sirene_Download },
  props: ["sirene", "selected", "hovered"],
  name: "Sirene",
  data: () => ({
    loader: null,
    snackbar: false, // Steuerung des Snackbars
  }),
  methods: {
    formatTimestamp(ts) {
      // ci_logs-Zeitstempel kommen als ISO mit Offset (UTC). dayjs formatiert in der
      // Zone des Browsers, die Kachel zeigt damit Ortszeit.
      return dayjs(ts).format("YYYY-MM-DD HH:mm:ss");
    },
    status() {
      this.loader = "status";
      this.sendCommand("status");
      setTimeout(() => (this.loader = null), 5000);
    },
    sperren() {
      //this.loader = "sperren";
      //this.sendCommand("sperren");
      this.$store.state.general.dialogs.push({title: 'Sirene wirklich sperren?', text: '', reason:"Grund für die Sperrung",  btn_1_title: 'Abbrechen', btn_2_title: 'Sperren', btn_2_update: { "payload_type": 'PUT', context: "/sirenen/" + this.sirene.id + "/command/sperren" }, btn_2_color: 'error', show: true})
      //setTimeout(() => (this.loader = null), 5000);
    },
    entsperren() {
      this.loader = "entsperren";
      this.sendCommand("entsperren");
      setTimeout(() => (this.loader = null), 5000);
    },
    notificationsUnmute() {
      this.$store.dispatch("update", {
        payload_type: "PUT",
        context: "/sirenen/" + this.sirene.id + "/notification/unmute",
      });
    },
    notificationsMute() {
      this.$store.dispatch("update", {
        payload_type: "PUT",
        context: "/sirenen/" + this.sirene.id + "/notification/mute",
      });
    },
    sendCommand(command) {
      this.$store.dispatch("update", {
        payload_type: "PUT",
        context: "/sirenen/" + this.sirene.id + "/command/" + command,
      });
    },
    copyToClipboard(text) {
      // Erstelle ein unsichtbares textarea-Element
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px"; // außerhalb des sichtbaren Bereichs
      document.body.appendChild(textarea);
      // Text auswählen und kopieren
      textarea.select();
      try {
        document.execCommand("copy");
        this.snackbar = true; // Zeige Snackbar an
      } catch (err) {
        console.error("Fehler beim Kopieren in die Zwischenablage: ", err);
      }

      // textarea-Element entfernen
      document.body.removeChild(textarea);
    },
    hasRecentMessage({ match, maxAgeMs }) {
      const now = Date.now();

      const relevant = this.messages.filter(msg => {
        if (typeof match === "function") return match(msg.message);
        if (typeof match === "string") return msg.message.includes(match);
        return false;
      });
      if (!relevant.length) return false;
      // dayjs wertet den Offset aus. Vorher wurde er per split("+") abgeschnitten und
      // der UTC-Wert als Lokalzeit gelesen - das Alter war damit 2h zu klein.
      return now - dayjs(relevant[0].timestamp).valueOf() <= maxAgeMs;
    },
  },
  computed: {
    noRecentStatusMessage() {
      return !this.hasRecentMessage({
        match: msg => msg.startsWith("Status"),
        maxAgeMs: 7 * 24 * 60 * 60 * 1000,
      });
    },
    recentAlarmActive() {
      return this.hasRecentMessage({
        match: msg => msg.includes("Alarm aktiv"),
        maxAgeMs: 30 * 60 * 1000,
      });
    },
    battery_voltage() {
      let voltage = parseFloat(this.sirene.safi_AccumulatorVoltage);
      if(this.noRecentStatusMessage){
        return ["mdi-battery-sync-outline", "error"];
      } else if (voltage < 23) {
        return ["mdi-battery-alert-variant-outline", "error"];
      } else if (voltage < 23.8) {
        return ["mdi-battery-30", "warning"];
      } else if (voltage < 24.2) {
        return ["mdi-battery-50", "warning"];
      } else if (voltage < 24.72) {
        return ["mdi-battery-70", "success"];
      } else if (voltage > 26) {
        return ["mdi-battery-90", "success"];
      } else {
        return ["mdi-battery-80", "success"];
      }
    },
    batteryVoltagePercent() {
      const totalV = parseFloat(this.sirene.safi_AccumulatorVoltage);
      if (isNaN(totalV)) return null;

      const vPerBatt = totalV / 2;
      // Am besten noch einen Offset für Ruhespannung einbauen.
      const table = [
        { v: 12.73, pct: 100 },
        { v: 12.62, pct: 90 },
        { v: 12.5, pct: 80 },
        { v: 12.37, pct: 70 },
        { v: 12.24, pct: 60 },
        { v: 12.1, pct: 50 },
        { v: 11.96, pct: 40 },
        { v: 11.81, pct: 30 },
        { v: 11.66, pct: 20 },
        { v: 11.51, pct: 10 },
        { v: 10.5, pct: 0 },
      ];

      if (totalV >= 28.0) {
        return 100;
      }

      if (vPerBatt >= table[0].v) return 100;
      if (vPerBatt <= table[table.length - 1].v) return 0;

      for (let i = 0; i < table.length - 1; i++) {
        const a = table[i];
        const b = table[i + 1];
        if (vPerBatt <= a.v && vPerBatt >= b.v) {
          const t = (vPerBatt - b.v) / (a.v - b.v);
          const pct = b.pct + t * (a.pct - b.pct);
          return Math.round(pct);
        }
      }
      return null;
    },
    messages() {
      if (!this.sirene.ci_id) return [];
      const ci_id = this.sirene.ci_id;
      let messages = this.$store.state.ticketsystem.ci_logs_by_ci[ci_id].filter(
        (log) => log.loglevel > 0
      );
      return messages.sort((a, b) => b.timestamp.localeCompare(a.timestamp))
        //let messages = this.$store.state.ticketsystem.ci_logs.filter((log) => log.ci_id === this.sirene.ci_id && log.loglevel > 0);
    },
    warn_state() {
      // Keine Infos
      if (this.sirene.safi_timestamp === "n/a") {
        return ["info", "mdi-help", "No Data"];
      }
      // Gesperrt
      const firstRelevantIndex = this.messages.findIndex(
        (msg) =>
          msg.message.startsWith("Status -") ||
          msg.message.startsWith("Sirene Entsperren") ||
          msg.message.includes("Sirene Sperren") ||
          msg.message.includes("Netzausfall 230V") ||
          msg.message.includes("Batteriefehler") ||
          msg.message.includes("Sammelfehler")
      );
      const firstRelevantMsg = this.messages[firstRelevantIndex];
      if (firstRelevantMsg) {
        if (firstRelevantMsg.message.includes("Netzausfall 230V")) {
          return ["error", "mdi-lightning-bolt-outline"];
        }
        else if(
          firstRelevantMsg.message.includes("Batteriefehler") ||
          firstRelevantMsg.message.includes("Sammelfehler"))
        {
          return ["error", "mdi-alert-outline"];
        }
        else if (firstRelevantMsg.message.includes("Sirene Sperren")) {
          return ["error", "mdi-lock-outline"];
        }
        else if (
          firstRelevantMsg.message.startsWith("Status -") &&
          this.sirene.safi_ActionNumber === "63"
        ) {
          return ["error", "mdi-lock-outline"];
        }
      }
      // Wichtige Fehler
      if (this.sirene.safi_ActionNumber === "63") {
        return ["warning", "mdi-check-circle-outline"];
      }
      if (this.sirene.doorcontact_open) {
        return ["error", "mdi-alert-outline"];
      }
      if (
        (this.sirene.safi_ActionNumber !== "0" &&
          this.sirene.safi_ActionNumber !== "63") ||
        this.sirene.safi_Mains !== "OK" ||
        this.sirene.safi_TestValid !== "OK" ||
        this.sirene.safi_InvalidPathsOfAmplifiers !== "0" ||
        this.noRecentStatusMessage
      ) {
        return ["error", "mdi-alert-outline"];
      }
      // Alles okay
      return ["success", "mdi-check-circle-outline"];
    },
    isGesperrt() {
      return true;
    },
  },
};
</script>

<style scoped>
.battery-wrapper {
  position: relative;
  display: inline-block;
}

.battery-text {
  position: absolute;
  top: 0px;
  right: -7px;
  font-size: 0.55rem;
  line-height: 1;
  color: inherit; /* gleiche Farbe wie Icon, wenn du willst */
  pointer-events: none; /* stört Tooltip nicht */
  opacity: 0.8; /* subtiler Look */
}
</style>
